import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('organizations');

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getOrganizations = createSelector(
  getState,
  (state: State) => state.data
);

